import { Box, Typography } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var StageError = function StageError() {
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      position: 'fixed',
      top: '50%'
    },
    "data-element": "Box",
    "data-component": "StageError",
    "data-source-file": "stage-error.tsx",
    children: [/*#__PURE__*/_jsx(Typography, {
      variant: "h3",
      component: "div",
      "data-element": "Typography",
      "data-component": "StageError",
      "data-source-file": "stage-error.tsx",
      children: "Can't preview this stage"
    }), /*#__PURE__*/_jsx(Typography, {
      "data-element": "Typography",
      "data-source-file": "stage-error.tsx",
      children: "You're missing some fields"
    })]
  });
};

export default StageError;